/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_DescriptionInputs */



/**
* | output |
* | --- |
* | "We offer easy and affordable pricing with no commitment." |
*
* @param {Signup_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_description = /** @type {((inputs?: Signup_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous offrons une tarification simple et abordable sans engagement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir bieten einfache und günstige Preise ohne Vertragsbindung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offriamo prezzi facili e convenienti, senza impegno.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мы предлагаем простые и доступные цены без каких-либо обязательств.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ofrecemos precios fáciles y asequibles sin compromiso.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("我们提供简单便捷且价格实惠的定价方案，无需任何承诺。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("私たちは、契約義務のない、簡単で手頃な価格を提供しています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हम बिना किसी प्रतिबद्धता के आसान और किफायती मूल्य निर्धारण की पेशकश करते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Oferecemos preços fáceis e acessíveis, sem compromisso.")
	return /** @type {LocalizedString} */ ("We offer easy and affordable pricing with no commitment.")
});